// Marginalia register helpers — `EDITION I · LESSON N · FRAME M / 2,200` for
// kanji frames, `EDITION I · LESSON N · PRIMITIVE` for primitive frames. Pure
// formatting; no domain logic. Roman edition number locked at I per §1 of the
// spine; lesson zero-padded so the strip aligns tabular across the sequence.
// Primitives are unnumbered by decision: their decimal frame numbers are a
// storage artifact, and they never counted toward the 2,200 — the category
// word replaces both the number and the denominator.
const TOTAL_FRAMES = 2200

export function formatLessonNumber(n: number): string {
    return String(n).padStart(2, '0')
}

export function formatFrameOfTotal(frame: number): string {
    return `${frame} / ${TOTAL_FRAMES.toLocaleString('en-US')}`
}

export function formatMarginalia(lessonNumber: number, frame: number): string {
    return `EDITION I · LESSON ${formatLessonNumber(lessonNumber)} · FRAME ${formatFrameOfTotal(frame)}`
}

export function formatPrimitiveMarginalia(lessonNumber: number): string {
    return `EDITION I · LESSON ${formatLessonNumber(lessonNumber)} · PRIMITIVE`
}
